import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { isNil } from 'lodash-es';

import i18n from 'portal-base/src/decorators/i18n';

import { KiDsPwaComponent } from '../../base/ki-ds-pwa-component';
import nls from '../../locales/indexes.nls';
import { skeletonStyles } from '../../styles/skeleton.css';
import style from './ki-ds-pwa-alarm-status.css';

const CLASS_NAME = 'ki-ds-pwa-alarm-status';

const LEVEL_CONFIG = {
    2: { state: 'good', icon: 'hmtmobile-check', label: 'normal' },
    3: { state: 'warning', icon: 'hmtmobile-circle-question', label: 'warning' },
    4: { state: 'alarm', icon: 'hmtmobile-triangle-exclamation', label: 'alarm' },
};

@i18n(nls)
@customElement(CLASS_NAME)
export class KiDsPwaAlarmStatus extends KiDsPwaComponent {
    static styles = [style, skeletonStyles];

    static get properties() {
        return {
            statusList: { type: Array },
            levels: { type: Array },
            isLoading: { type: Boolean },
        };
    }

    constructor() {
        super();
        this.statusList = null;
        this.levels = null;
        this.isLoading = false;
    }

    get _levels() {
        if (this.levels) return this.levels;
        // Derive from LEVEL_CONFIG — show all known levels that have a config entry
        return Object.entries(LEVEL_CONFIG)
            .map(([lvl, cfg]) => ({ level: Number(lvl), ...cfg }))
            .sort((a, b) => b.level - a.level);
    }

    __countByLevel(level) {
        if (isNil(this.statusList)) return '-';
        return this.statusList.reduce((count, entry) => count + (entry.level === level ? 1 : 0), 0);
    }

    render() {
        if (this.isLoading) {
            return this._renderSkeleton();
        }

        return html`
            <link rel="stylesheet" href="./embedded-woff2.css" />
            <div class="alarm-status hydrated">
                <div class="alarm-overview">
                    ${this._levels.map((cfg) => this._renderLevel(cfg))}
                </div>
            </div>
        `;
    }

    _renderLevel({ level, state, icon, label }) {
        return html`
            <div class="status-entry">
                <div class="status-icon-circle alarm-status-${state}">
                    <i class="hmtmobile ${icon}"></i>
                </div>
                <div class="status-counter">
                    <span class="counter-value">${this.__countByLevel(level)}</span>
                    <div class="counter-label">${this.i18n.t(label)}</div>
                </div>
            </div>
        `;
    }

    _renderSkeleton() {
        return html`
            <div class="alarm-status">
                <div class="alarm-overview">
                    ${Array.from(
            { length: 3 },
            () => html`
                            <div class="status-entry">
                                <div
                                    class="skeleton skeleton-circle"
                                    style="width: 2.5ch; height: 2.5ch; min-width: 40px; min-height: 40px;"
                                ></div>
                                <div class="status-counter">
                                    <div
                                        class="skeleton skeleton-block"
                                        style="width: 3ch; height: 1.7rem;"
                                    ></div>
                                    <div
                                        class="skeleton skeleton-block"
                                        style="width: 5ch; height: 0.9rem; margin-top: 4px;"
                                    ></div>
                                </div>
                            </div>
                        `,
        )}
                </div>
            </div>
        `;
    }
}
